/**
 * @file Node.js の環境変数を使用します。
 * 環境変数を直接使用できない、SFCの`<template>`内で使用したいときに利用します。
 * `<script>`の中では特にわざわざ使う意味ないです。
 */

/**
 * `process.env`のエイリアスです。
 */
export const env = process.env

/**
 * `process.env.NODE_ENV`が`development`のときに`true`が返ります。
 */
export const isDev = process.env.NODE_ENV === 'development'

/**
 * `process.env.NODE_ENV`が`production`のときに`true`が返ります。
 */
export const isProd = process.env.NODE_ENV === 'production'
